import type { Moment } from '../types'

type SessionsTimelineInput = {
    [moment: Moment]: number
}

type SessionsTimelineGroupedInput = {
    [type: string]: SessionsTimelineInput
}

type SessionsTimeLineGroupedData = {
    [fixture: string]: number[]
}

type SessionsTimeLineGroupedLabels = Moment[]

export interface SessionsTimelineGroupedOutput {
    values: SessionsTimeLineGroupedData
    labels: SessionsTimeLineGroupedLabels
    total: number
    perc: number | null
}

type SessionsTimeLineGroupedReducer = [SessionsTimeLineGroupedData, SessionsTimeLineGroupedLabels?]

/**
 * Sessions timeline grouped by data type
 * @param {object} state
 */
function sessionsTimelineGrouped<Group extends string = string>(payload = {}): SessionsTimelineGroupedOutput {
    const data = payload as SessionsTimelineGroupedInput
    const dataGroups = Object.keys(data) as Group[]

    // Iterate every type in the object
    const [values, momentLabels]: SessionsTimeLineGroupedReducer = dataGroups.reduce(
        (carry: SessionsTimeLineGroupedReducer, groupKey: Group): SessionsTimeLineGroupedReducer => {
            const dataGroup: SessionsTimelineInput = data[groupKey]

            // If the labels are not defined yet, take all moments from this type's data
            const labels: SessionsTimeLineGroupedLabels = carry[1] || (Object.keys(dataGroup) as SessionsTimeLineGroupedLabels)

            // Extract all values from this type's data
            return [
                {
                    ...carry[0],
                    [groupKey]: labels.map((label) => dataGroup[label]),
                },
                labels,
            ]
        },
        [{}]
    )

    const labels = momentLabels as SessionsTimeLineGroupedLabels

    return {
        values,
        labels,
        total: labels.length,
        perc: null,
    }
}

export default sessionsTimelineGrouped
